/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useState, useContext, useEffect } from 'react';
import { Button, Input, InputLabel, Modal, Search, Select } from '@scuf/common';
import descriptors from '../../locales/en-US/descriptors';
import {
  IAny,
  IRequestContext
} from '../DashboardKPIWidgets/IEnergyManagementProps';
import { useTranslation } from '@scuf/localization';
import { useUtilityAccountContext } from '../../context/UtilityAccountContext/UtilityAccountContext';
import UtilityAccountAction from '../../context/UtilityAccountContext/UtilityAccountActions';
// import './ConversionModalComponent.scss';
import './EditAccountDetailsCommon.scss';
import useConnectorForPost from '../shared/useConnectorAndDynamicProps/useConnectorForPost';
// import { IAllConnectDetails, IUtilityProviders } from '../UtilityServiceModal/IUtilityService';
import { ApiContext } from '../../context/ApiContext';
import { getEnrollNotifyInfo } from '../shared/Utils/UtilitySettings/UtilitySettingsUtils';
import { isLoadingCheck } from '../shared/Utils/UtilityViewDetails';
import {
  convertUtilityProvidersToOptions,
  debounce,
  isObjectEmpty,
  SpecialCharacter,
  validateConnecttabInput
} from '../shared/Utils/Utils';
import { v4 as uuid4 } from 'uuid';
import useConnectorAndDynamicProps from '../shared/useConnectorAndDynamicProps/useConnectorAndDynamicProps';
import {
  IAllConnectDetails,
  ICommonServiceProps,
  IEditAccountDetails,
  IManualAccountDetails,
  IUtilityProviders
} from '../UtilityServiceModal/IUtilityService';
import ProgressTab from '../UtilityServiceModal/ProgressTab/ProgressTab';
import Editdetailstab from '../UtilityServiceModal/ChooseServiceTab/Editdetailstab';
import EditDetailsutilityform from '../UtilityServiceModal/EditDetailsutilityform';
import useMounted from '../shared/useMount/useMount';

function EditDetails(props: IAny) {
  const d = descriptors.energyManagement;
  const [t] = useTranslation();
  const { bearerToken } = props;
  const [utilityTyp, setUtilityTyp] = useState('Manual');
  const [state, dispatch] = useUtilityAccountContext();

  const {
    showModal,
    showConversionModal,
    selectedUtility,
    editDetailsModal,
    valueDetails
  } = state;

  let { requestContext, utilityType, utilityCellData } = props;
  const closeModal = () => {
    //setAllConnectDetails(initDetails);
    SetSelectedUtilityProvider({} as IUtilityProviders);
    setSubmitted(false);
    dispatch(UtilityAccountAction.hideeditDetailsModal());
    //setManualAccountUtility(([] as any) as IEditAccountDetails);
    setManualAccountUtility([] as IEditAccountDetails);
    setUtilityTyp('Manual');
    setProgressTab(false);
    setAddUtilityTable(false);
    emaasContext.setUtilityCellData(false);
    setData(false);
  };
  const [SelectedUtilityProvider, SetSelectedUtilityProvider] = useState<
    IUtilityProviders
  >({} as IUtilityProviders);
  const [isSubmitted, setSubmitted] = useState(false);
  const [isDisabled, setDisabled] = useState(true);
  const [manualDisabled, setManualDisabled] = useState(false);
  const [accUtility, setAccUtility] = useState({
    accountNumber: '',
    utility: ''
  });
  const [manualAccountUtility, setManualAccountUtility] = useState<
    IEditAccountDetails
  >([] as IEditAccountDetails);
  const [addUtilityTable, setAddUtilityTable] = useState(false);
  const [progressTab, setProgressTab] = useState(false);
  const [isSpecialCharacter, setIsSpecialCharacter] = useState(false);
  const [isSubmitDisable, setSubmitDisabled] = useState(true);
  const isMounted = useMounted();
  const connectorConfigforbillcheck = {
    name: 'manage-utility-Bill',
    routes: {
      logicalAccountId: valueDetails ? valueDetails.logicalAccountId : null,
      utilityType: valueDetails ? valueDetails.utilityType : null
    }
  };
  const [dataConnectorforbillcheck] = useConnectorAndDynamicProps({
    connectorConfig: connectorConfigforbillcheck,
    requestContext,
    bearerToken
  });

  useEffect(() => {
    if (valueDetails) {
      dataConnectorforbillcheck.actions.getAll();
    }
  }, [valueDetails]);

  const { all, loading, error, status } =
    valueDetails && valueDetails.logicalAccountId
      ? dataConnectorforbillcheck.data
      : { all: [], loading: false, error: '', status: 204 };
  const [isLoading, setIsLoading] = useState<boolean>(loading);
  const monthYearData = (all as unknown) as IAny;
  const [data, setData] = useState(([] as unknown) as IAny);
  const [statusCode, setStatusCode] = useState<number | null>(0);
  const [errorInfo, setErrorInfo] = useState(error);
  const chooseServiceProps = {
    bearerToken: bearerToken,
    requestContext: requestContext,
    SetSelectedUtilityProvider: SetSelectedUtilityProvider,
    SelectedUtilityProvider: SelectedUtilityProvider,
    utilityTyp: utilityTyp,
    setIsSpecialCharacter: setIsSpecialCharacter,
    isSpecialCharacter: isSpecialCharacter,
    isDataAvailablebill: data,
    valueDetails: valueDetails
  };

  const emaasContext = useContext(ApiContext);
  const ProgressTabProps = {
    closeModal: closeModal
  };

  const connectorConfig = {
    name:
      //   utilityTyp === 'Automated'
      //     ? 'enroll-utility-accounts'
      //     :
      state.selectedUtility.integrationType === 'Automatic'
        ? 'edit-automatic-account'
        : 'enroll-manual-utility-account'
  };
  const dataConnector = useConnectorForPost({
    connectorConfig,
    requestContext,
    bearerToken
  });

  const isDataAvailable = monthYearData ? true : false;
  const onRefresh = () => {
    dataConnector && dataConnector.actions && dataConnector.actions.getAll();
  };

  useEffect(() => {
    if (isMounted) {
      onRefresh();
    }
  }, [requestContext]);

  useEffect(() => {
    setIsLoading(loading);
    if (
      (monthYearData && monthYearData.length && monthYearData.length === 0) ||
      status === 204
    ) {
      setData([]);
      utilityCellData && utilityCellData.integrationType === 'Manual';
    }
    if ((isDataAvailable || error || status) && !loading) {
      if (isDataAvailable) {
        setData(monthYearData.data);
      }
      setErrorInfo(error);
      setStatusCode(status);
    }
  }, [isDataAvailable, loading, status]);
  //------------------

  useEffect(() => {
    SetSelectedUtilityProvider({} as IUtilityProviders);
    setSubmitted(false);
    // setManualAccountUtility(([] as any) as IEditAccountDetails);
    setAddUtilityTable(false);
  }, [utilityTyp]);

  useEffect(() => {
    if (
      !isObjectEmpty(SelectedUtilityProvider) &&
      manualAccountUtility &&
      manualAccountUtility.length > 0
    ) {
      setManualDisabled(false);
    } else {
      setManualDisabled(true);
    }
  }, [manualAccountUtility, SelectedUtilityProvider]);

  const connectProps = {
    //allConnectDetails: allConnectDetails,
    //setAllConnectDetails: setAllConnectDetails,
    isSubmitted: isSubmitted,
    //validateMandatoryFields: validateMandatoryFields,
    setAccUtility: setAccUtility,
    accUtility: accUtility,
    addUtilityTable: addUtilityTable,
    setAddUtilityTable: setAddUtilityTable,
    utilityTyp: utilityTyp,
    setManualAccountUtility: setManualAccountUtility,
    manualAccountUtility: manualAccountUtility,
    isDataAvailablebill: data,
    setSubmitDisabled: setSubmitDisabled,
    emaasContext: emaasContext,
    selectedUtility: selectedUtility
  };
  const apiContext = useContext(ApiContext);
  const { notifyMessage } = apiContext;

  const specialChars = /[`!#$%^@+\=\\;:\\|<>\/?~]/;

  const serviceTypeId: { [key: string]: string } = {
    Electricity: '2FFEE473-07FB-436E-AFCC-0B13464B1B7E',
    Gas: '344F9FD4-B18B-4B4A-A654-D9D9015A1CC3',
    Water: 'B59557AB-7DE3-4013-AFFE-8EAE68F2099B',
    Sewer: 'DE8FFAD6-E4BD-4809-8C96-9B980FAA62EF'
  };

  const specialCharacterCheck = (value: string) => specialChars.test(value);
  const manualSubmit = async () => {
    if (!specialCharacterCheck(SelectedUtilityProvider.utilityProviderName)) {
      setSubmitted(true);
      let requestBody;
      if (state.selectedUtility.integrationType === 'Automatic') {
        requestBody = {
          serviceProviderId: SelectedUtilityProvider.utilityProviderId,
          serviceProviderName: SelectedUtilityProvider.utilityProviderName,
          newAccountNumber: (manualAccountUtility as IAny)[0].accountNumber,
          subscribed: true,
          pullHistory: true,
          siteId: emaasContext.siteId,
          utilityAccountId: state.selectedUtility.utilityAccountId,
          accountDetails:
            manualAccountUtility.length > 0 &&
            manualAccountUtility.map((account) => {
              // const manualUtiltyData = JSON.parse(
              //   account.utility ? account.utility : ''
              // );
              return {
                accountNumber: state.selectedUtility.accountNumber,
                // serviceTypeId: manualUtiltyData.id,
                // serviceTypeName: manualUtiltyData.name,
                serviceTypeId: serviceTypeId[account.utility],
                serviceTypeName: account.utility
              };
            })
        };
      } else {
        requestBody = {
          serviceProviderId: SelectedUtilityProvider.utilityProviderId,
          serviceProviderName: SelectedUtilityProvider.utilityProviderName,
          subscribed: true,
          pullHistory: true,
          siteId: emaasContext.siteId,
          manualAccountDetails:
            manualAccountUtility.length > 0 &&
            manualAccountUtility.map((account) => {
              // const manualUtiltyData = JSON.parse(
              //   account.utility ? account.utility : ''
              // );
              return {
                accountNumber: account.accountNumber,
                // serviceTypeId: manualUtiltyData.id,
                // serviceTypeName: manualUtiltyData.name,
                serviceTypeId: serviceTypeId[account.utility],
                serviceTypeName: account.utility,
                consumptionUnit: account.consumptionUnit,
                demandUnit: account.demandUnit,
                currencyUnit: account.currencyUnit,
                utilityAccountId: account.utilityAccountId,
                manualMeterDetails: account.manualMeterDetails
              };
            })
        };
      }

      setProgressTab(true);
      let result;
      if (state.selectedUtility.integrationType === 'Automatic') {
        result = await dataConnector.actions.update('', requestBody);
      } else {
        result = await dataConnector.actions.create(requestBody);
      }

      const { notifyDescription, notifyType } = getEnrollNotifyInfo(result);
      closeModal();
      notifyMessage && notifyMessage(t(notifyDescription), notifyType);
    } else {
      setIsSpecialCharacter(true);
    }
  };

  return (
    <Modal
      className="emaas-Edit-Detail-modal"
      size="small"
      closeIcon={true}
      onClose={closeModal}
      open={editDetailsModal}
      closeOnDimmerClick={false}
    >
      <div className="edit-detail-header">{t(d.EDIT_ACCOUNT_DETAILS)}</div>
      <Modal.Content className="utlity-modal-content">
        {/* <p>{t(d.EDITDETAILNOTE)}</p> */}
        {progressTab ? (
          <ProgressTab utilityType={utilityTyp} {...ProgressTabProps} />
        ) : (
          <div className="edit-detail-form-container">
            <Editdetailstab {...chooseServiceProps} />
            <EditDetailsutilityform {...connectProps} />
            {/* <UtilityModalForm {...connectProps} /> */}
          </div>
        )}
      </Modal.Content>
      <Modal.Footer className="edit-detail-modal-footer">
        <Button
          type="secondary"
          content={t(d.CANCEL)}
          onClick={closeModal}
        ></Button>
        <Button
          type="primary"
          content={t(d.SUBMIT)}
          onClick={manualSubmit}
          disabled={isSubmitDisable || isSubmitted}
        ></Button>
      </Modal.Footer>
    </Modal>
  );
}

export default EditDetails;
